// Third-party
import Grid from '@mui/material/Grid2';

import { TableFooter } from './Table/TableFooter';
import { useSheetsPermissions } from '../hooks';

const TimesheetsHeader = () => {
  const { permissions } = useSheetsPermissions();

  return (
    <Grid alignItems="center" marginTop={2} container spacing={2}>
      <Grid
        display="flex"
        size={{
          xs: 12,
          md: 12,
          lg: 12,
          sm: 12,
        }}
      >
        {permissions.isAllowViewSalaryData && <TableFooter />}
      </Grid>
    </Grid>
  );
};

export {
  TimesheetsHeader,
};
